module.exports = __webpack_public_path__ + "img/9-01-rozvodna.b736e845.jpg";